import { MessageCircle, Phone, Send } from "lucide-react";
import { PHONE, WHATSAPP_LINK } from "./shared";

export default function QuickActions() {
  return (
    <div className="quick-actions" data-testid="quick-actions">
      <a data-testid="quick-call-button" className="qa-call" href={`tel:${PHONE}`}><Phone size={16}/><span>Call</span></a>
      <a data-testid="quick-whatsapp-button" className="qa-whatsapp" href={WHATSAPP_LINK} target="_blank" rel="noreferrer"><MessageCircle size={16}/><span>WhatsApp</span></a>
      <a data-testid="quick-enquiry-button" className="qa-enquiry" href="/#contact"><Send size={15}/><span>Enquiry</span></a>
    </div>
  );
}
